import { Editor } from "primereact/editor";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineBook } from "react-icons/ai";

import { CardDescription } from "../../../styled"

export function BibliographyForm(props: any) {
    const { t: translation } = useTranslation();

    const { updateData = false , handleSetValue, itemData} = props

    useEffect(() => {
        if(itemData?.reference){
            setBibliography(itemData.reference);
        }
    }, [])

    const [bibliography, setBibliography] = useState<any>();

    return (
        <>
            <CardDescription className="mb-5">
                <div className="title mb-2"><AiOutlineBook fontSize={20} style={{ marginTop: '-5px' }}></AiOutlineBook> {translation('material.bibliography')}</div>
                {
                    updateData ? (
                        <Editor style={{ height: '150px' }} value={bibliography} onTextChange={(e) => { setBibliography(e.htmlValue); handleSetValue('reference', e.htmlValue)}}/>
                    ) : (
                        <>
                            <div dangerouslySetInnerHTML={{ __html: itemData?.reference  }}></div>
                        </>)
                }
            </CardDescription>
        </>
    )
}